import { Badge } from "react-bootstrap";
import { useRef } from "react";
import { FaEdit } from "react-icons/fa";

import { Card } from "../../../../../../../components/global";
import Masks from "../../../../../../../shared/utils/mask.utils";
import { GovPlanSecretaryProject } from "../../model/project";
import { GovPlanSecretaryProjectProgressChart } from "./charts/progress";
import { GovPlanSecretaryProjectBudgetChart } from "./charts/budget";
import { EditSecretaryProject, EditSecretaryProjectModalHandles } from "./edit";

export type GovPlanProjectDetailsProps = {
    project: GovPlanSecretaryProject;
};

export const GovPlanProjectDetails = ({
    project,
}: GovPlanProjectDetailsProps) => {
    const editRef = useRef<EditSecretaryProjectModalHandles>(null);
    return (
        <div className="grid gap-x-2 gap-y-2 grid-cols-2">
            <Card
                title={`Secretaria: ${project.secretary.name}`}
                titleRight={
                    <button
                        type="button"
                        className="text-teal-700"
                        onClick={() => editRef.current?.open(project)}
                    >
                        <FaEdit />
                    </button>
                }
            >
                <div>
                    <span className="font-semibold">Andamento: </span>
                    {project.projectProgress}%
                </div>

                <div>
                    <span className="font-semibold">Nome: </span>
                    {project.name}
                </div>
                <div>
                    <span className="font-semibold">Descrição: </span>
                    {project.description}
                </div>
                <hr />
                <div>
                    <span className="font-semibold">Valor de execução: </span>
                    {!!project.amount || project.amount === 0
                        ? Masks.currency(project.amount)
                        : "Não informado"}
                </div>
                <div
                    className={
                        project.remainingBudget >= 0
                            ? "text-green-500"
                            : "text-red-500"
                    }
                >
                    <span className="font-semibold">Valor restante: </span>
                    {Masks.currency(project.remainingBudget)}
                </div>
                <hr />

                <div>
                    <span className="font-semibold">Data limite </span>
                    {Masks.date(project.deadline.toISOString())}
                </div>

                {project.completedAt && (
                    <div>
                        <span className="font-semibold">Completado em: </span>
                        {Masks.date(project.completedAt.toISOString())}
                    </div>
                )}

                {project.canceledAt && (
                    <div>
                        <span className="font-semibold">Cancelado em: </span>
                        {Masks.date(project.canceledAt.toISOString())}
                    </div>
                )}

                <div>
                    <span className="font-semibold">Status: </span>
                    <Badge
                        className="capitalize"
                        bg={project.isCompleted() ? "success" : "warning"}
                    >
                        {project.status}
                    </Badge>
                </div>

                <hr />

                <div>
                    <span className="font-semibold">Observação: </span>
                    {project.observation || "Sem observação"}
                </div>

                <hr />

                <div>
                    <span className="font-semibold">Criado em: </span>
                    {Masks.date(project.createdAt.toISOString())}
                </div>
                <div>
                    <span className="font-semibold">Última atualização: </span>
                    {Masks.date(project.updatedAt.toISOString())}
                </div>
            </Card>
            <Card title="Progresso">
                <div className="h-[40vh]">
                    <GovPlanSecretaryProjectProgressChart project={project} />
                </div>
            </Card>
            <Card title="Composição do orçamento" className="col-span-2">
                <div className="h-[40vh]">
                    <GovPlanSecretaryProjectBudgetChart project={project} />
                </div>
            </Card>
            <EditSecretaryProject ref={editRef} />
        </div>
    );
};
